<!--
 * @Description  : 场地维护 - 新增/编辑/查看场地门禁
 * @Author       : zcc
 * @Date         : 2025-04-09 10:01:48
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-18 09:11:23
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\field-management\components\entrance-guard-dialog.vue
-->
<template>
  <div class="">
    <el-form
      ref="entranceGuardForm"
      label-width="130px"
      :model="entranceGuardForm"
      :rules="entranceGuardRule"
    >
      <el-row>
        <el-col :span="21" :offset="1">
          <el-form-item label="归属场地：" required>
            <el-select
              v-model="entranceGuardForm.sname"
              placeholder="请选择"
              @change="placeChange"
              :disabled="type != 'add'"
              clearable
            >
              <el-option
                v-for="item in placeList"
                :key="item.id"
                :label="item.sname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="21" :offset="1">
          <el-form-item label="门禁名称：" required>
            <el-input
              placeholder="请输入内容"
              v-model.trim="entranceGuardForm.accessName"
              :maxlength="50"
              :disabled="type == 'view'"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="21" :offset="1">
          <el-form-item label="品牌：">
            <el-input
              placeholder="请输入内容"
              v-model.trim="entranceGuardForm.accessBrand"
              :maxlength="50"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="21" :offset="1">
          <el-form-item label="设备名称：" required>
            <el-input
              placeholder="请输入内容"
              v-model.trim="entranceGuardForm.accessDevice"
              :maxlength="50"
              :disabled="type == 'view'"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="21" :offset="1">
          <el-form-item label="设备序列号：" required>
            <el-input
              placeholder="请输入内容"
              v-model.trim="entranceGuardForm.accessSerial"
              :maxlength="50"
              :disabled="type == 'view'"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="21" :offset="1">
          <el-form-item label="设备型号：" required>
            <el-input
              placeholder="请输入内容"
              v-model.trim="entranceGuardForm.accessModel"
              :maxlength="50"
              :disabled="type == 'view'"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="21" :offset="1">
          <el-form-item label="IP地址：" prop="accessIp">
            <el-input
              placeholder="请输入内容"
              v-model.trim="entranceGuardForm.accessIp"
              :maxlength="100"
              :disabled="type == 'view'"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  addOrUpdateMeetingDoorInfo,
  getOperateSiteData,
  getMeetingDoorInfo
} from "api/modules/fieldManagement";
import XEUtils from "xe-utils";
export default {
  props: {
    entranceGuardRow: {
      type: Object,
      default: () => {}
    }, //父组件中选中行的id
    entranceGuardType: {
      type: String,
      default: "add"
    } //新增/编辑/查看
  },
  data() {
    return {
      name: "entranceGuardDialog",
      entranceGuardForm: {
        id: "", // 归属场地
        sname: "", //
        accessName: "", // 门禁名称
        accessBrand: "海康威视", // 品牌
        accessDevice: "", // 设备名称
        accessSerial: "", // 设备序列号
        accessModel: "", // 设备型号
        accessIp: "" //IP地址
      }, // 场地门禁表单参数
      type: "add", // 对话框状态 新增/编辑/查看
      entranceGuardRule: {
        accessIp: [
          { required: true, message: "请输入 IPv4 地址", trigger: "blur" },
          {
            pattern: /^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
            message: "请输入合法的 IPv4 地址（如 192.168.1.1）",
            trigger: "blur"
          }
        ]
      }, // 场地门禁表单规则
      placeList: [] // 归属场地列表
    };
  },
  watch: {
    entranceGuardRow: {
      handler: function(newVal) {
        this.entranceGuardForm = newVal;
        this.entranceGuardForm.accessBrand = "海康威视";
      },
      deep: true, // 确认是否深入监听。（一般监听时是不能监听到对象属性值的变化的，数组的值变化可以听到。）
      immediate: true // 确认是否以当前的初始值执行handler的函数。
    },
    entranceGuardType: {
      handler: function(newVal) {
        this.type = newVal;
      },
      deep: true, // 确认是否深入监听。（一般监听时是不能监听到对象属性值的变化的，数组的值变化可以听到。）
      immediate: true // 确认是否以当前的初始值执行handler的函数。
    }
  },
  mounted() {
    this.getOperateSiteData(); // 获取场地信息
  },
  methods: {
    //重置表单
    reset() {
      let that = this;
      Object.keys(that.entranceGuardForm).forEach(function(key) {
        if (key != "accessBrand") {
          that.entranceGuardForm[key] = ""; //除了品牌 其他全部重置为""
        }
      });
    },
    // 获取场地信息
    getOperateSiteData() {
      this.placeList = []; // 清空 归属场地列表
      getOperateSiteData({}).then(res => {
        if (res.code == 0) {
          this.placeList = res.data; // 赋值 归属场地列表
        }
      });
    },
    // 选中场地信息 将sname赋值给form
    placeChange(e) {
      this.entranceGuardForm.id = e;
      this.entranceGuardForm.sname = XEUtils.find(
        this.placeList,
        i => i.id == e
      )?.sname;
    },
    // 查看门禁信息
    getMeetingDoorInfo() {
      getMeetingDoorInfo({ id: this.entranceGuardForm.id }).then(res => {
        if (res.code == 0) {
          this.entranceGuardForm = res.data; // 获取表单信息
        }
      });
    },
    // 保存场地门禁
    saveEntranceGuard() {
      this.$refs.entranceGuardForm.validate(valid => {
        if (valid) {
          addOrUpdateMeetingDoorInfo(this.entranceGuardForm).then(res => {
            if (res.code == 0) {
              this.$parent.$parent.entranceGuardCloseAndRefresh(); // 关闭对话框并刷新页面
              this.type == "add"
                ? this.$message.success("新增成功！")
                : this.$message.success("修改成功！"); // 根据type 返回正确信息
            } else {
              this.type == "add"
                ? this.$message.success("新增失败！")
                : this.$message.success("修改失败！"); // 根据type 返回错误信息
            }
          });
        } else {
          this.$message.warning("请检验表单");
        }
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
